import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { API_ENDPOINTS, API_SLICE, BASE_URL } from '@/utils/constants/apiEndpoints';

export interface PatientDiagnosisCode {
  id: string;
  code: string;
  description: string;
  isPrimary: boolean;
  createdAt: string;
}

export interface AddDiagnosisRequest {
  diagnosisCode: string;
  patientId: string;
}

export interface DeleteDiagnosisRequest {
  diagnosisId: string;
  patientId: string;
}

export interface ClearAllDiagnosesRequest {
  patientId: string;
}

export const patientDiagnosesApi = createApi({
  reducerPath: 'patientDiagnosesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: [API_SLICE.PatientDiagnoses],
  endpoints: (builder) => ({
    updatePrimaryDiagnosis: builder.mutation<void, { diagnosisId: string; patientId: string }>({
      query: ({ diagnosisId }) => ({
        url: `${API_ENDPOINTS.PATIENT_DIAGNOSES.UPDATE_PRIMARY(diagnosisId)}`,
        method: 'PATCH',
        body: {
          isPrimary: true
        }
      }),
      invalidatesTags: (_result, _error, { patientId }) => [
        { type: API_SLICE.PatientDiagnoses, id: patientId }
      ]
    }),
    clearAllDiagnoses: builder.mutation<void, { patientId: string }>({
      query: ({ patientId }) => ({
        url: `${API_ENDPOINTS.PATIENT_DIAGNOSES.CLEAR_ALL(patientId)}`,
        method: 'DELETE'
      }),
      invalidatesTags: (_result, _error, { patientId }) => [
        { type: API_SLICE.PatientDiagnoses, id: patientId }
      ]
    })
  })
});

export const { useUpdatePrimaryDiagnosisMutation, useClearAllDiagnosesMutation } =
  patientDiagnosesApi;
